'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _map = require('lodash/map');

var _map2 = _interopRequireDefault(_map);

var _includes = require('lodash/includes');

var _includes2 = _interopRequireDefault(_includes);

var _mergeWith = require('lodash/mergeWith');

var _mergeWith2 = _interopRequireDefault(_mergeWith);

var _isArray = require('lodash/isArray');

var _isArray2 = _interopRequireDefault(_isArray);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var generateReducer = function generateReducer(initialState, generatedActions) {
  // save actionsTypes in an array to avoid re-iteration
  var actionsTypes = (0, _map2.default)(generatedActions, function (action) {
    return action().type;
  });

  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];
    return (0, _includes2.default)(actionsTypes, action.type) ? (0, _mergeWith2.default)({}, state,
    // if the payload is a function we'll inject state into it
    typeof action.payload === 'function' ? action.payload(state) : action.payload, function (dest, src) {
      return (0, _isArray2.default)(dest) ? src : undefined;
    }) : state;
  };
};

exports.default = generateReducer;